<script lang="tsx">
import { type Moment } from 'moment'
import {
  defineComponent,
  inject,
  ref, type PropType, type Ref,
} from 'vue'
import { DefaultButton, ModalWindow, type ModalWindowInterface } from '../../../../lib'
import Calendar from '../../../calendars/calendars/calendar'
import CalendarInput from '../../../calendars/inputs/calendar-input'
import { type ComputedColumnInterface } from '../../DefaultTableInterfaces'
import { CalendarTableFilter } from '../../filters/Filters'
import HeaderSort from './DefaultTableHeaderSort.vue'

export default defineComponent({
  props: {
    column: {
      type: Object as PropType<ComputedColumnInterface>,
      required: true,
    },
    sortField: {
      type: String,
      required: true,
    },
    enableSorting: {
      type: Boolean,
    },
    sortOrder: {
      type: Boolean as PropType<boolean>,
      default: undefined,
    },
    onSort: {
      type: Function as PropType<() => void>,
      default: undefined,
    },
  },
  setup(props) {
    const modal = ref<ModalWindowInterface|undefined>()
    const isUseModalFilters: Ref<boolean> | undefined = inject('isUseModalFilters')

    const filter: CalendarTableFilter = props.column.filter as unknown as CalendarTableFilter

    const setValue = (val: Moment | null) => {
      filter.addValue(val)
    }

    const setIsModalOpen = (value: boolean) => {
      if (!isUseModalFilters?.value) return

      if (modal.value) {
        if (value) modal.value.open()
        else modal.value.close()
      }
    }

    return () => (

      <div class="default-table-header default-table-calendar-header">
        <span onClick={() => setIsModalOpen(true)}>
          <CalendarInput
            isForTable

            modelValue={filter.date}
            placeholder={props.column.name}

            onValueChange={setValue}
          />
        </span>

        { props.enableSorting && props.onSort && (
          <HeaderSort column={props.column} onSort={props.onSort} sortField={props.sortField} sortOrder={props.sortOrder}/>
        ) }

        <ModalWindow
          class="ark-ui-table-header-modal"

          ref={modal}
          slots={{
            head: props.column.name,
            body: () => (
              <div class="ark-ui-table-header-modal-body">
                <Calendar date={filter.date} onSetDate={setValue} />
              </div>
            ),
            footer: () => [
              <DefaultButton label="Отмена" type="secondary" onClick={() => setIsModalOpen(false)} />,
              <DefaultButton label="Применить" onClick={() => setIsModalOpen(false)} />,
            ],
          }}
        />
      </div>

    )
  },
})
</script>

<style lang="scss" scoped>
.default-table-calendar-header {
  display: flex;
  padding-right: 12px;

  > *:first-child {
    width: 100%;
  }

  &.active,
  &:hover {
    & path {
      fill: #585B69;
    }
  }
}
</style>
